// Routes that render the logo-only shell: no left nav, no header.
export const LOGO_ONLY_ROUTES = [
  '/purchase/treasurybill',
  '/manage/treasury-bill/:id',
  '/purchase/confirmation',
  '/auth/login',
  '/auth/register',
  '/reset-password',
  '/forgot-password',
  '/business-select',
  '/wallet/add-money',
  '/wallet/withdraw',
  '/welcome',
  '/login',
  '/signup',
];

/** A static route also matches its sub-paths; a `:param` segment matches exactly one segment. */
export const matchesRoute = (pathname: string, routes: string[]): boolean =>
  routes.some((route) => {
    if (route.includes(':')) {
      return new RegExp(`^${route.replace(/:[^/]+/g, '[^/]+')}$`).test(pathname);
    }
    return pathname === route || pathname.startsWith(route + '/');
  });

export const isLogoOnlyRoute = (pathname: string): boolean =>
  matchesRoute(pathname, LOGO_ONLY_ROUTES);
